import apiFetch from '../apiFetch'

export default function (serviceId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Service/${serviceId}/CompleteSpareParts`, method: 'PUT', body: null, token: token, lastAccessDate })
}
